import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import {
  Button,
  Card,
  Chip,
  Tooltip,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
  FormControlLabel,
} from '@mui/material';
import { getDoctors } from '../../apis/doctorSlice';
// import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PaymentIcon from '@mui/icons-material/Payment';
import ArticleIcon from '@mui/icons-material/Article';

import HistoryIcon from '@mui/icons-material/History';
import { toast } from 'react-toastify';
import {
  completeSession,
  deleteAppointment,
  getAllAppointments,
  updateAppointment,
} from '../../apis/appointmentSlice';
import moment from 'moment/moment';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SearchDoctor from '../../components/Autocomplete/SearchDoctor';
import SearchPatient from '../../components/Autocomplete/SearchPatient';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AssessmentIcon from '@mui/icons-material/Assessment';
import Style from '../patientForm/doctor.module.scss';
import PatientFormDialog from '../patientForm/PatientFormDialog';
import PaymentDialog from '../patientForm/PaymentDialog';
import TransactionHistoryDialog from '../patientForm/TransactionHistoryDialog';
import { set } from 'lodash';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import SessionDialog from './SessionDialog';
import SessionDialogPackage from './SessionDialogPackage';
import SessionSummaryDialog from './SessionSummaryDialog';
import { ApiHeaderWithToken } from '../../common/apisHeaders';
import axios from 'axios';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import FilterIcon from '@mui/icons-material/Filter';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

import SessionEnhancementDialog from './SessionEnhancementDialog';
import DeleteDialog from '../../components/DeleteDialog';
import pageStyles from './AppointmentPage.module.scss';
import CommonAgGrid from '../../components/CommonAgGrid/CommonAgGrid';

export default function AppointmentPage({ search }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [filter, setFilter] = useState(false);
  const [patientData, setPatientData] = useState(null);
  const [doctorData, setDoctorData] = useState(null);
  const [isDisabled, setIsDisabled] = useState(true);
  const [message, setMessage] = useState('');
  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection',
      color: '#3d91ff',
    },
  ]);
  // quick filter state: 'today', 'week', 'month' or ''
  const [activeRange, setActiveRange] = useState('today');

  // helpers to build ranges
  const applyRange = (start, end, name) => {
    setDateRange([
      {
        startDate: start,
        endDate: end,
        key: 'selection',
        color: '#3d91ff',
      },
    ]);
    setActiveRange(name);
  };

  const selectToday = () => {
    const today = new Date();
    applyRange(today, today, 'today');
  };

  const selectLastWeek = () => {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 7);
    applyRange(start, end, 'week');
  };

  const selectLastMonth = () => {
    const end = new Date();
    const start = new Date();
    start.setMonth(start.getMonth() - 1);
    applyRange(start, end, 'month');
  };

  // initialize date range to today on mount, or from query params if available
  useEffect(() => {
    const startDateParam = searchParams.get('startDate');
    const endDateParam = searchParams.get('endDate');

    if (startDateParam && endDateParam) {
      // Use query params if available
      const startDate = moment(startDateParam).toDate();
      const endDate = moment(endDateParam).toDate();
      setDateRange([
        {
          startDate: startDate,
          endDate: endDate,
          key: 'selection',
          color: '#3d91ff',
        },
      ]);
      setActiveRange(''); // Clear active range since it's from URL params
      setIsDateFilterExplicit(true);
    } else {
      // Default to today if no query params
      selectToday();
      setIsDateFilterExplicit(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState({});
  const [operationMode, setOperationMode] = useState('Edit');
  const [openPayment, setOpenPayment] = useState(false);
  const [openTransaction, setOpenTransaction] = useState(false);
  const [selectedApptId, setSelectedApptId] = useState(null);
  const [selectedApptData, setSelectedApptData] = useState(null);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [selectedPatientFormId, setSelectedPatientFormId] = useState(null);
  const [appointmentOptions, setAppointmentOptions] = useState([]);
  const [selectedAppointmentDate, setSelectedAppointmentDate] = useState(null);
  const [loadingInvoice, setLoadingInvoice] = useState(false);
  const [loadingReceipt, setLoadingReceipt] = useState(false);
  const [loadingPrescription, setLoadingPrescription] = useState(false);
  const [loadingDateWiseReport, setLoadingDateWiseReport] = useState(false);
  const [approvedAppointmentId, setApprovedAppointmentId] = useState(null);

  // Document generation options (stamp/signature)
  const [docGenDialogOpen, setDocGenDialogOpen] = useState(false);
  const [docGenType, setDocGenType] = useState(null);
  const [docGenIncludeSignAndStamp, setDocGenIncludeSignAndStamp] = useState(true);
  const [docActionType, setDocActionType] = useState('generatereport');
  const [isDateFilterExplicit, setIsDateFilterExplicit] = useState(false);

  const resolveId = (data) => {
    if (!data) return '';
    return (
      data?.doctor?.value ||
      data?.value ||
      data?._id ||
      data?.doctor?._id ||
      data?.patient?._id ||
      data?.patient?._id ||
      ''
    );
  };

  const { loggedIn } = useSelector((state) => state.authData);
  const { appointments, apptLoading, totalCount } = useSelector((state) => state.appointmentData);

  // const totalCount = appointments?.length || 0;
  async function callApi() {
    // Check if any query params are present
    const hasQueryParams =
      searchParams.get('approvedAppointmentId') ||
      searchParams.get('patientId') ||
      searchParams.get('doctorId') ||
      searchParams.get('startDate') ||
      searchParams.get('endDate');

    const payload = {
      page: approvedAppointmentId ? 0 : page,
      pageSize: approvedAppointmentId ? 10000 : pageSize, // Fetch all when filtering
      search: search || '',
      doctorId: resolveId(doctorData) || '',
      patientId: resolveId(patientData) || '',
    };

    const hasDoctorOrPatientFilter = Boolean(payload.doctorId || payload.patientId);
    const shouldApplyDateFilter = !hasQueryParams && (!hasDoctorOrPatientFilter || isDateFilterExplicit);

    // For doctor/patient selections, apply date only after user explicitly sets it.
    if (shouldApplyDateFilter) {
      if (dateRange[0]?.startDate) {
        payload.startDate = moment(dateRange[0].startDate).startOf('day').toISOString();
      }

      if (dateRange[0]?.endDate) {
        payload.endDate = moment(dateRange[0].endDate).endOf('day').toISOString();
      }
    }

    dispatch(getAllAppointments(payload));
  }

  useEffect(() => {
    callApi();
  }, [
    page,
    pageSize,
    dispatch,
    loggedIn,
    search,
    patientData,
    doctorData,
    dateRange,
    approvedAppointmentId,
  ]);

  useEffect(() => {
    if (!doctorData) {
      setIsDisabled(true);
      setMessage('Please select a doctor');
      return;
    }

    if (!patientData) {
      setIsDisabled(true);
      setMessage('Please select a patient');
      return;
    }

    // if (!dateRange[0]?.startDate) {
    //   setIsDisabled(true);
    //   setMessage('Please select start date');
    //   return;
    // }

    // if (!dateRange[0]?.endDate) {
    //   setIsDisabled(true);
    //   setMessage('Please select end date');
    //   return;
    // }

    setIsDisabled(false);
    setMessage('');
  }, [doctorData, patientData, dateRange]);

  // Handle multiple query params: approvedAppointmentId, patientId, doctorId
  useEffect(() => {
    const appointmentIdFromUrl = searchParams.get('approvedAppointmentId');
    const patientIdFromUrl = searchParams.get('patientId');
    const doctorIdFromUrl = searchParams.get('doctorId');

    // Set approved appointment ID if present
    if (appointmentIdFromUrl) {
      setApprovedAppointmentId(appointmentIdFromUrl);
      toast.info('Showing approved appointment');
    } else {
      setApprovedAppointmentId(null);
    }

    // Set patient data if present in query params
    if (patientIdFromUrl) {
      setPatientData({ _id: patientIdFromUrl });
    }

    // Set doctor data if present in query params
    if (doctorIdFromUrl) {
      setDoctorData({ _id: doctorIdFromUrl });
    }
  }, [searchParams]);

  const appointmentDateForUrl = selectedAppointmentDate
    ? moment(selectedAppointmentDate).format('DD/MM/YYYY')
    : '';

  const doctorIdForUrl = resolveId(doctorData) || '';
  const patientIdForUrl = resolveId(patientData) || '';

  const reportUrl = `${process.env.REACT_APP_BACKEND_API}/appointment/generatereport?doctor=${doctorIdForUrl}&patient=${patientIdForUrl}&startDate=${appointmentDateForUrl}&endDate=${appointmentDateForUrl}`;

  const receiptUrl = `${process.env.REACT_APP_BACKEND_API}/appointment/generatereceipt?doctor=${doctorIdForUrl}&patient=${patientIdForUrl}&startDate=${appointmentDateForUrl}&endDate=${appointmentDateForUrl}`;

  const prescriptionUrl = `${process.env.REACT_APP_BACKEND_API}/appointment/generateprescription?doctor=${doctorIdForUrl}&patient=${patientIdForUrl}&startDate=${appointmentDateForUrl}&endDate=${appointmentDateForUrl}`;
  const datewiseReportUrl = `${process.env.REACT_APP_BACKEND_API}/appointment/generatedatewisereport?doctor=${doctorIdForUrl}&patient=${patientIdForUrl}&startDate=${appointmentDateForUrl}&endDate=${appointmentDateForUrl}`;

  // const handleGenerate = (type) => {
  //   const base = `${process.env.REACT_APP_BACKEND_API}/appointment/`;

  //   // If an appointment is selected and has a patientFormId, prefer that
  //   if (
  //     selectedAppointment &&
  //     selectedAppointment.patientFormId &&
  //     selectedAppointment.patientFormId._id
  //   ) {
  //     const pid = selectedAppointment.patientFormId._id;
  //     const url = `${base}${type}?patientFormId=${pid}`;
  //     window.open(url, '_blank');
  //     return;
  //   }

  //   // Fallback to previous behaviour (doctor + patient + appointmentDate)
  //   if (type === 'generatereport') window.open(reportUrl, '_blank');
  //   else if (type === 'generatereceipt') window.open(receiptUrl, '_blank');
  //   else if (type === 'generateprescription') window.open(prescriptionUrl, '_blank');
  // };

  //commented old code
  // const handleGenerate = async (type) => {
  //   const base = `${process.env.REACT_APP_BACKEND_API}/appointment/`;
  //   let url = '';

  //   // Prefer patientFormId if available
  //   if (
  //     selectedAppointment?.patientFormId?._id
  //   ) {
  //     url = `${base}${type}?patientFormId=${selectedAppointment.patientFormId._id}`;
  //   } else {
  //     // Fallback
  //     if (type === 'generatereport') url = reportUrl;
  //     else if (type === 'generatereceipt') url = receiptUrl;
  //     else if (type === 'generateprescription') url = prescriptionUrl;
  //   }

  //   if (!url) return;

  //   try {
  //     const response = await fetch(url, {
  //       method: 'GET',
  //       ...ApiHeaderWithToken(), // 🔥 token injected here
  //     });

  //     if (!response.ok) {
  //       throw new Error('Failed to generate document');
  //     }

  //     const blob = await response.blob();
  //     const blobUrl = window.URL.createObjectURL(blob);
  //     window.open(blobUrl, '_blank');
  //   } catch (error) {
  //     console.error(error);
  //     alert('Unable to generate document');
  //   }
  // };

  const openGenerateDialog = (type) => {
    setDocGenType(type || docActionType);
    setDocGenIncludeSignAndStamp(true);
    setDocGenDialogOpen(true);
  };

  const handleGenerate = async (type, { includeSignature = true, includeStamp = true } = {}) => {
    // Set loading state based on document type
    if (type === 'generatereport') setLoadingInvoice(true);
    else if (type === 'generatereceipt') setLoadingReceipt(true);
    else if (type === 'generateprescription') setLoadingPrescription(true);
    else if (type === 'generatedatewisereport') setLoadingDateWiseReport(true);

    const base = `${process.env.REACT_APP_BACKEND_API}/appointment/`;
    let url = '';

    // Prefer patientFormId if available
    if (selectedAppointment?.patientFormId?._id) {
      url = `${base}${type}?patientFormId=${selectedAppointment.patientFormId._id}`;
    } else {
      // Fallback
      if (type === 'generatereport') url = reportUrl;
      else if (type === 'generatereceipt') url = receiptUrl;
      else if (type === 'generateprescription') url = prescriptionUrl;
      else if (type === 'generatedatewisereport') url = datewiseReportUrl;
    }

    if (url) {
      url += `${url.includes('?') ? '&' : '?'}includeSignature=${includeSignature}&includeStamp=${includeStamp}`;
    }

    if (!url) {
      // Reset loading state if no URL
      if (type === 'generatereport') setLoadingInvoice(false);
      else if (type === 'generatereceipt') setLoadingReceipt(false);
      else if (type === 'generateprescription') setLoadingPrescription(false);
      else if (type === 'generatedatewisereport') setLoadingDateWiseReport(false);
      return;
    }

    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        responseType: 'blob',
      });

      const blobUrl = URL.createObjectURL(response.data);
      window.open(blobUrl, '_blank');
    } catch (error) {
      console.error(error);
      alert('Unable to generate document');
    } finally {
      // Reset loading state
      if (type === 'generatereport') setLoadingInvoice(false);
      else if (type === 'generatereceipt') setLoadingReceipt(false);
      else if (type === 'generateprescription') setLoadingPrescription(false);
      else if (type === 'generatedatewisereport') setLoadingDateWiseReport(false);
    }
  };

  const handlePaginationModelChange = (model) => {
    setPage(model.page);
    setPageSize(model.pageSize);
  };

  const handleEdit = (data) => {
    // navigate(`/appointmentform/${data._id}`);
    setOpen(true);
    setEditData(data);
    setOperationMode('Edit');
  };

  // const handleVisitStatus = (data) => {
  //   dispatch(updateAppointment({ ...data, visitStatus: true })).then(() => {
  //     callApi();
  //   });
  // };

  const handleDelete = async (data) => {
    const response = await dispatch(deleteAppointment(data._id));

    if (response?.payload?.success) {
      toast.success(response?.payload.message);
      callApi();
    } else {
      toast.error('Error deleting appointment');
    }
  };

  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);

  const handleDeleteClick = (data) => {
    setDeleteRow(data);
    setDeleteOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!deleteRow) return;
    await handleDelete(deleteRow);
    setDeleteOpen(false);
    setDeleteRow(null);
  };

  const handleCancelDelete = () => {
    setDeleteOpen(false);
    setDeleteRow(null);
  };

  const [openSessionDialog, setOpenSessionDialog] = useState(false);
  const [openPackageSessionDialog, setOpenPackageSessionDialog] = useState(false);
  const [packageEditMode, setPackageEditMode] = useState(false);
  const [sessionForm, setSessionForm] = useState({
    sessionNo: 1,
    treatment: '',
    sessionDesc: '',
    payment: 0,
    paidAmount: 0,
    remainingAmount: 0,
    paymentMode: 'cash',
  });
  const [selectedApptForSession, setSelectedApptForSession] = useState(null);
  const [doctorOptions, setDoctorOptions] = useState([]);
  const [openSummaryDialog, setOpenSummaryDialog] = useState(false);
  const [selectedApptForSummary, setSelectedApptForSummary] = useState(null);
  const [selectedSessions, setSelectedSessions] = useState([]);
  const [openEnhancementDialog, setOpenEnhancementDialog] = useState(false);

  const { doctors } = useSelector((state) => state.doctorData || { doctors: [] });

  useEffect(() => {
    // load doctors for select
    dispatch(getDoctors({ page: 0, pageSize: 1000 }));
  }, [dispatch]);

  useEffect(() => {
    if (doctors) setDoctorOptions(doctors);
  }, [doctors]);

  useEffect(() => {
    const opts = (appointments || []).map((a) => ({
      _id: a._id,
      label: `${a.patient?.name || a.patientId?.name || 'Patient'} - ${
        a.appointmentDate ? moment(a.appointmentDate).format('DD/MM/YYYY') : 'N/A'
      } - ${a.startTime || ''}`,
      appointment: a,
    }));
    setAppointmentOptions(opts);
  }, [appointments]);

  // clear selected appointment date when patient changes
  useEffect(() => {
    setSelectedAppointmentDate(null);
    setSelectedAppointment(null);
    setSelectedPatientFormId(null);
  }, [patientData]);

  const toggleSelectAppointment = (appt) => {
    if (!appt) return;
    if (selectedAppointment && selectedAppointment._id === appt._id) {
      setSelectedAppointment(null);
      setSelectedPatientFormId(null);
      setSelectedAppointmentDate(null);
    } else {
      setSelectedAppointment(appt);
      setSelectedPatientFormId(appt?.patientFormId?._id || null);
      // Auto-set appointment date from the selected appointment
      setSelectedAppointmentDate(appt.appointmentDate || null);
    }
  };

  const handleOpenSession = (appt) => {
    const nextSessionNo = (appt.sessions && appt.sessions.length + 1) || 1;
    const treatmentVal = appt.treatment || appt.patientFormId?.treatment || '';
    const paymentVal = appt.payment || 0;
    setSelectedApptForSession(appt);
    setSessionForm({
      sessionNo: nextSessionNo,
      treatment: treatmentVal,
      sessionDesc: '',
      payment: paymentVal,
      paidAmount: 0,
      remainingAmount: paymentVal,
      paymentMode: 'cash',
    });
    setOpenSessionDialog(true);
  };

  const handleOpenPackageSession = (appt) => {
    // reuse same selected appointment variable
    setSelectedApptForSession(appt);
    setPackageEditMode(false);
    setOpenPackageSessionDialog(true);
  };

  const handleOpenPackageUpdate = (appt) => {
    // open package dialog in edit/manage payments mode
    setSelectedApptForSession(appt);
    setPackageEditMode(true);
    setOpenPackageSessionDialog(true);
  };

  const handleSessionFormChange = (field, value) => {
    setSessionForm((p) => {
      const next = { ...p, [field]: value };
      if (field === 'paidAmount' || field === 'payment') {
        const paymentNum = Number(next.payment || 0);
        const paidNum = Number(next.paidAmount || 0);
        next.remainingAmount = Math.max(0, paymentNum - paidNum);
      }
      return next;
    });
  };

  //   const handleSaveSession = async (formData) => {
  //     if (!formData.sessionDate) return toast.error('Please select session date');

  //     // formData comes from SessionDialog
  //     if (!selectedApptForSession) return;
  //     const appt = selectedApptForSession;
  //     // const newSession = {
  //     //   sessionNo: formData.sessionNo,
  //     //   doctorId: formData.doctorId || appt.doctorId?._id || appt.doctorId,
  //     //   treatment: formData.treatment || appt.treatment || appt.patientFormId?.treatment,
  //     //   sessionDesc: formData.sessionDesc,
  //     //   sessionDate: formData.sessionDate ? new Date(formData.sessionDate) : undefined,
  //     //   payment: Number(formData.payment || 0),
  //     //   paidAmount: Number(formData.paidAmount || 0),
  //     //   remainingAmount: Number(formData.remainingAmount || 0),
  //     //   paymentMode: formData.paymentMode,
  //     //   paymentLogs: formData.paidAmount
  //     //     ? [
  //     //         {
  //     //           paidAmount: Number(formData.paidAmount || 0),
  //     //           receiveBy: (loggedIn && loggedIn.userId) || null,
  //     //           paymentDate: new Date(),
  //     //         },
  //     //       ]
  //     //     : [],
  //     // };

  //     const newSession = {
  //       sessionNo: formData.sessionNo,
  //       doctorId: formData.doctorId || appt.doctorId?._id || appt.doctorId,
  //       treatment: formData.treatment || appt.treatment || appt.patientFormId?.formData?.treatment,

  //       sessionDesc: formData.sessionDesc,
  //       sessionDate: formData.sessionDate ? new Date(formData.sessionDate) : undefined,

  //       attachments: formData.attachments || [],

  //       // 🔥 IMPORTANT FIX STARTS HERE
  //       prescribeMedicine: formData.prescribeMedicine === 'yes' ? 'yes' : 'no',

  //       prescriptions: formData.prescribeMedicine === 'yes' ? formData.prescriptions || [] : [],
  //       // 🔥 IMPORTANT FIX ENDS HERE

  //       payment: Number(formData.payment || 0),
  //       paidAmount: Number(formData.paidAmount || 0),
  //       remainingAmount: Number(formData.remainingAmount || 0),
  //       paymentMode: formData.paymentMode,

  //       paymentLogs: formData.paidAmount
  //         ? [
  //             {
  //               paidAmount: Number(formData.paidAmount || 0),
  //               receiveBy: (loggedIn && loggedIn.userId) || null,
  //               paymentDate: new Date(),
  //             },
  //           ]
  //         : [],
  //     };

  //     let updatedSessions = [];

  //     if (!appt.isSessionTaken) {
  //   // convert planned calendar slot into first completed session
  //   updatedSessions = [newSession];
  // } else {
  //   // normal follow-up
  //   updatedSessions = [...(appt.sessions || []), newSession];
  // }

  // const payload = {
  //   _id: appt._id,
  //   sessions: updatedSessions,
  //   isSessionTaken: true,
  // };

  //     // const updatedSessions = [...(appt.sessions || []), newSession];

  //     // const payload = {
  //     //   _id: appt._id,
  //     //   sessions: updatedSessions,
  //     //   isSessionTaken: true,
  //     // };

  //     const response = await dispatch(updateAppointment(payload));
  //     if (response?.payload?.success) {
  //       toast.success('Session added');
  //       setOpenSessionDialog(false);
  //       callApi();
  //     } else {
  //       toast.error('Error adding session');
  //     }
  //   };
  const handleSaveSession = async (formData) => {
    if (!formData.sessionDate) {
      return toast.error('Please select session date');
    }

    if (!selectedApptForSession) return;

    const appt = selectedApptForSession;

    const nextSessionNo = appt.isSessionTaken ? (appt.sessions?.length || 0) + 1 : 1;

    const newSession = {
      sessionNo: nextSessionNo,

      doctorId: formData.doctorId || appt.doctorId?._id || appt.doctorId,

      treatment: formData.treatment || appt.treatment || appt.patientFormId?.formData?.treatment,
      sessionDesc: formData.sessionDesc || '',
      sessionDate: new Date(formData.sessionDate),
      attachments: formData.attachments || [],
      prescribeMedicine: formData.prescribeMedicine === 'yes' ? 'yes' : 'no',
      prescriptions: formData.prescribeMedicine === 'yes' ? formData.prescriptions || [] : [],
      payment: Number(formData.payment || 0),
      paidAmount: Number(formData.paidAmount || 0),
      remainingAmount: Number(formData.remainingAmount || 0),
      paymentMode: formData.paymentMode || null,
      isSessionTaken: true,
      paymentLogs: formData.paidAmount
        ? [
            {
              paidAmount: Number(formData.paidAmount),
              receiveBy: loggedIn?.userId || null,
              paymentDate: new Date(),
            },
          ]
        : [],
    };

    let updatedSessions = [];

    if (!appt.isSessionTaken) {
      updatedSessions = [newSession];
    } else {
      updatedSessions = [...(appt.sessions || []), newSession];
    }

    // const payload = {
    //   _id: appt._id,
    //   sessions: updatedSessions,
    // };

    const payload = {
      _id: appt._id,

      sessionDate: formData.sessionDate,
      startTime: formData.startTime,
      endTime: formData.endTime,
      sessionDesc: formData.sessionDesc,

      doctorId: formData.doctorId,
      treatment: formData.treatment,

      payment: formData.payment,
      paidAmount: formData.paidAmount,
      remainingAmount: formData.remainingAmount,
      paymentMode: formData.paymentMode,

      attachments: formData.attachments,
      prescribeMedicine: formData.prescribeMedicine,
      prescriptions: formData.prescriptions,
    };

    // const response = await dispatch(updateAppointment(payload));
    const response = await dispatch(completeSession(payload));

    if (response?.payload?.success) {
      toast.success(`Session ${formData.sessionNo} saved successfully`);
      setOpenSessionDialog(false);

      callApi();
    } else {
      toast.error('Error adding session');
    }
  };

  const handleSavePackageSession = async ({ sessions: newSessions, totalPayment }) => {
    if (!selectedApptForSession) return;
    const appt = selectedApptForSession;
    const updatedSessions = packageEditMode ? newSessions : [...(appt.sessions || []), ...newSessions];
    const payload = {
      _id: appt._id,
      sessions: updatedSessions,
    };
    const response = await dispatch(updateAppointment(payload));
    if (response?.payload?.success) {
      toast.success(packageEditMode ? 'Package payments updated' : 'Package sessions added');
      setOpenPackageSessionDialog(false);
      setPackageEditMode(false);
      callApi();
    } else {
      toast.error('Error adding sessions');
    }
  };

  const columns = [
    {
      field: 'select',
      headerName: <div className="gridHeaderText">Select</div>,
      width: 56,
      sortable: false,
      filterable: false,
      renderCell: (params) =>
        params.row.docApproval !== 'rejected' && (
          <Checkbox
            className={pageStyles.rowSelectCheckbox}
            checked={selectedAppointment && selectedAppointment._id === params.row._id}
            onChange={() => toggleSelectAppointment(params.row)}
            inputProps={{ 'aria-label': 'select appointment' }}
            // disabled={!patientData || !doctorData}
          />
        ),
    },
    {
      field: 'actions',
      headerName: <div className="gridHeaderText">Actions</div>,
      width: 210,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className={pageStyles.actionCell}>
          {/* <Tooltip title="Edit">
            <IconButton
              onClick={() => handleEdit(params.row)}
              color="primary"
              aria-label="edit"
              disabled={params.row.docApproval == 'rejected'}
            >
              <EditIcon />
            </IconButton>
          </Tooltip> */}

          <Tooltip title="Delete">
            <IconButton
              onClick={() => handleDeleteClick(params.row)}
              color="error"
              aria-label="delete"
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>

          {/* <Tooltip title="Generate Certificate">
            <IconButton
              onClick={() => {
                const url = `${process.env.REACT_APP_BACKEND_API}/appointment/generatecertificate?id=${params.row._id}`;
                window.open(url, '_blank');
              }}
              color="success"
              aria-label="generate-certificate"
              disabled={params.row.docApproval == 'rejected'}
            >
              <WorkspacePremiumIcon />
            </IconButton>
          </Tooltip> */}

          {/* <Tooltip title="Generate Certificate">
  <IconButton
    onClick={async () => {
      try {
        const url = `${process.env.REACT_APP_BACKEND_API}/appointment/generatecertificate?id=${params.row._id}`;

        const response = await fetch(url, {
          method: 'GET',
          ...ApiHeaderWithToken(), // 🔐 token passed here
        });

        if (!response.ok) {
          throw new Error('Failed to generate certificate');
        }

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
      } catch (error) {
        console.error(error);
        alert('Unable to generate certificate');
      }
    }}
    color="success"
    aria-label="generate-certificate"
    disabled={params.row.docApproval === 'rejected'}
  >
    <WorkspacePremiumIcon />
  </IconButton>
</Tooltip> */}

          <Tooltip title="Generate Certificate">
            <IconButton
              onClick={async () => {
                try {
                  const url = `${process.env.REACT_APP_BACKEND_API}/appointment/generatecertificate?id=${params.row._id}`;

                  const response = await axios.get(url, {
                    // If ApiHeaderWithToken() returns object like { Authorization: `Bearer ${token}` }
                    ...ApiHeaderWithToken(),

                    responseType: 'blob', // ← very important for files/certificates/PDFs
                  });

                  // Create blob url and open in new tab
                  const blob = new Blob([response.data], {
                    type: response.headers['content-type'] || 'application/pdf',
                  });

                  const blobUrl = window.URL.createObjectURL(blob);
                  window.open(blobUrl, '_blank');
                } catch (error) {
                  console.error('Certificate generation failed:', error);

                  // Better user feedback
                  const message =
                    error.response?.data?.message ||
                    error.message ||
                    'Unable to generate certificate. Please try again.';

                  alert(message);
                  // or use toast/snackbar notification system
                }
              }}
              color="success"
              aria-label="generate-certificate"
              disabled={params.row.docApproval === 'rejected'}
            >
              <WorkspacePremiumIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Assessment Form">
            <IconButton
              onClick={() => {
                navigate(`/assessmentform/${params.row.patientFormId._id}`);
              }}
              color="secondary"
              aria-label="assessment-form"
              disabled={params.row.docApproval == 'rejected'}
            >
              <AssessmentIcon />
            </IconButton>
          </Tooltip>
          {/* {params.row.patientFormId.formData?.treatment || params.row.patientFormId.formData?.estheticsQuestions?.skinConcern || params.row.patientFormId.formData?.dentalQuestions?.specificConcern && (
            <Tooltip title="Add Session">
              <IconButton
                color="primary"
                aria-label="add-session"
                onClick={() => handleOpenSession(params.row)}
                disabled={params.row.docApproval == 'rejected'}
              >
                <AddCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )} */}
          {(params.row.patientFormId.formData?.estheticsQuestions?.skinConcern ||
            params.row.patientFormId.formData?.dentalQuestions?.specificConcern) && (
            <Tooltip title="Add Follow Up">
              <IconButton
                color="primary"
                aria-label="add-session"
                onClick={() => handleOpenSession(params.row)}
                disabled={params.row.docApproval === 'rejected'}
              >
                <AddCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}

          {(params.row.patientFormId.formData?.treatment) && (
            <Tooltip title="Add Package">
              <IconButton
                color="primary"
                aria-label="add-package"
                onClick={() => handleOpenPackageSession(params.row)}
                disabled={params.row.docApproval === 'rejected'}
              >
                <AddCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}

          {/* update payments for existing package sessions */}
         

          {params.row.sessions?.some((session) => session.isSessionTaken === true) && (
            <Tooltip title="Summary of Sessions">
              <IconButton
                color="success"
                aria-label="payment"
                disabled={params.row.docApproval == 'rejected'}
                onClick={() => {
                  setSelectedApptForSummary(params.row);
                  setOpenSummaryDialog(true);
                }}
              >
                <ArticleIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.sessions?.some(
            (s) => Array.isArray(s.attachments) && s.attachments.length > 0,
          ) && (
            <Tooltip title="Treatment Enhancements">
              <IconButton
                color="info"
                aria-label="attachments"
                onClick={() => {
                  console.log(params.row.sessions);
                  setSelectedSessions(params.row.sessions || []);
                  setOpenEnhancementDialog(true);
                }}
              >
                <FilterIcon />
              </IconButton>
            </Tooltip>
          )}

          {(!params.row.patientFormId.formData?.treatment) && Array.isArray(params.row.sessions) &&
            params.row.sessions.some((session) => Number(session.remainingAmount) > 0) && (
              <Tooltip title="Add Payment">
                <IconButton
                  onClick={() => {
                    setSelectedApptId(params.row._id);
                    setSelectedApptData(params.row);
                    setOpenPayment(true);
                  }}
                  color="warning"
                  aria-label="payment"
                  disabled={params.row.docApproval === 'rejected'}
                >
                  <PaymentIcon />
                </IconButton>
              </Tooltip>
            )}

             {(params.row.patientFormId.formData?.treatment) && Array.isArray(params.row.sessions) &&
            params.row.sessions.some((session) => Number(session.remainingAmount) > 0) && (
            <Tooltip title="Update Package Payments">
              <IconButton
                color="warning"
                aria-label="update-package"
                onClick={() => handleOpenPackageUpdate(params.row)}
                disabled={params.row.docApproval === 'rejected'}
              >
                <PaymentIcon />
              </IconButton>
            </Tooltip>
          )}

          {/* {params.row.visitStatus !== true && (
            <Tooltip title="Visit Status">
              <IconButton
                onClick={() => handleVisitStatus(params.row)}
                color="info"
                aria-label="visit-status"
                disabled={params.row.docApproval == 'rejected'}
              >
                <HowToRegIcon />
              </IconButton>
            </Tooltip>
          )} */}

          {/* 
          {params.row.paymentLog.length !== 0 && (
            <Tooltip title="View Transaction History">
              <IconButton
                onClick={() => {
                  setSelectedApptData(params.row);
                  setOpenTransaction(true);
                }}
                color="info"
                aria-label="transaction-history"
                disabled={params.row.docApproval == 'rejected'}
              >
                <HistoryIcon />
              </IconButton>
            </Tooltip>
          )} */}
          {/* {params.row.docApproval === 'pending' && (
              <>
                <Tooltip title="Approve Appointment">
                  <IconButton
                    onClick={() => {
                      dispatch(updateAppointment({ ...params.row, docApproval: 'approved' })).then(
                        () => {
                          callApi();
                        },
                      );
                    }}
                    color="success"
                    aria-label="approve-appointment"
                  >
                    <CheckCircleOutlineIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Decline Appointment">
                  <IconButton
                    onClick={() => handleDeleteClick(params.row)}
                    color="error"
                    aria-label="decline-appointment"
                  >
                    <CancelIcon />
                  </IconButton>
                </Tooltip>
              </>
            )} */}
        </div>
      ),
    },
    {
      field: 'clinicName',
      headerName: <div className="gridHeaderText">Clinic Name</div>,
      renderCell: (params) => <div>{params && params.row && params.row.clinicId?.name}</div>,
      width: 150,
    },
    {
      field: 'doctor',
      headerName: <div className="gridHeaderText">Doctor Name</div>,
      renderCell: (params) => (
        <div>{params && params.row && (params.row.doctor?.name || params.row.doctorId?.name)}</div>
      ),
      width: 150,
    },
    {
      field: 'patient',
      headerName: <div className="gridHeaderText">Patient Name</div>,
      renderCell: (params) => (
        <div>
          {params && params.row && (params.row.patient?.name || params.row.patientId?.name)}
        </div>
      ),
      width: 170,
    },
    {
      field: 'patient.phone',
      headerName: <div className="gridHeaderText">Patient Phone</div>,
      renderCell: (params) => (
        <div>
          {params && params.row && (params.row.patient?.phone || params.row.patientId?.phone)}
        </div>
      ),
      width: 180,
    },
    {
      field: 'treatment',
      headerName: <div className="gridHeaderText">Treatment</div>,
      renderCell: (params) => (
        <div>
          {/* {params.row.patientFormId
            ? `${params && params.row && params.row?.patientFormId?.formData?.treatment}`
            : 'N/A'} */}
          {params?.row?.patientFormId?.formData?.treatment ||
            params?.row?.patientFormId?.formData?.dentalQuestions?.specificConcern ||
            params?.row?.patientFormId?.formData?.estheticsQuestions?.skinConcern ||
            'N/A'}
        </div>
      ),
      width: 200,
    },
    // {
    //   field: 'description',
    //   headerName: <div className="gridHeaderText">Description</div>,
    //   width: 300,
    // },
    {
      field: 'assessmentFee',
      headerName: <div className="gridHeaderText">Assessment Fee</div>,
      renderCell: (params) => (
        <div>
          {params.row.patientFormId
            ? `${params && params.row && params.row?.patientFormId?.payment}`
            : 'N/A'}
        </div>
      ),
      width: 150,
    },
    // {
    //   field: 'payment',
    //   headerName: <div className="gridHeaderText">Payment</div>,
    //   width: 120,
    // },
    // {
    //   field: 'remainingAmount',
    //   headerName: <div className="gridHeaderText">Remaining</div>,
    //   width: 120,
    // },
    // {
    //   field: 'paidAmount',
    //   headerName: <div className="gridHeaderText">Paid Amount</div>,
    //   width: 120,
    // },
    // {
    //   field: 'date',
    //   headerName: <div className="gridHeaderText">Date</div>,
    //   renderCell: (params) => (
    //     <div>
    //       {params && params.row && params.row.date && moment(params.row.date).format('DD/MM/YYYY')}
    //     </div>
    //   ),
    //   width: 150,
    // },
    {
      field: 'appointmentDate',
      headerName: <div className="gridHeaderText">Appt. Date</div>,
      renderCell: (params) => (
        <div>
          {params && params.row && params.row.appointmentDate
            ? moment(params.row.appointmentDate).format('DD/MM/YYYY')
            : 'N/A'}
        </div>
      ),
      width: 150,
    },

    {
      field: 'Time',
      headerName: <div className="gridHeaderText">Time</div>,
      renderCell: (params) => (
        <div>
          {params.row.startTime
            ? `${params && params.row && params.row.startTime} To ${
                params && params.row && params.row.endTime
              }`
            : 'N/A'}
        </div>
      ),
      width: 150,
    },
    // {
    //   field: 'visitStatus',
    //   headerName: <div className="gridHeaderText">Visit Status</div>,
    //   renderCell: (params) => (
    //     <div>
    //       {(params && params.row && params.row.visitStatus == true && (
    //         <Chip color="success" label="Visited" />
    //       )) ||
    //         'N/A'}
    //     </div>
    //   ),
    //   width: 120,
    // },
    {
      field: 'docApproval',
      headerName: <div className="gridHeaderText">Appointment Status</div>,
      renderCell: (params) => (
        <div>
          {params && params.row && params.row.docApproval == 'approved' ? (
            <Chip
              size="small"
              className={pageStyles.approvalChipSuccess}
              color="success"
              label="Approved"
            />
          ) : params.row.docApproval == 'rejected' ? (
            <Chip size="small" className={pageStyles.approvalChipError} color="error" label="Rejected" />
          ) : (
            'N/A'
          )}
        </div>
      ),
      width: 120,
    },
  ];

  const appointmentColumns = useMemo(
    () =>
      columns.map((col) => {
        const compactWidthByField = {
          select: 56,
          actions: 200,
          'patient.phone': 120,
          appointmentDate: 108,
          Time: 120,
          docApproval: 120,
        };
        const compactWidth = compactWidthByField[col.field];
        const isFixedCompactColumn = typeof compactWidth === 'number';

        const headerLabel =
          typeof col.headerName === 'string'
            ? col.headerName
            : col.field === 'select'
              ? 'Select'
              : col.field === 'actions'
                ? 'Actions'
                : col.field === 'clinicName'
                  ? 'Clinic Name'
                  : col.field === 'doctor'
                    ? 'Doctor Name'
                    : col.field === 'patient'
                      ? 'Patient Name'
                      : col.field === 'patient.phone'
                        ? 'Patient Phone'
                        : col.field === 'appointmentDate'
                          ? 'Appt. Date'
                          : col.field === 'docApproval'
                            ? 'Appointment Status'
                            : col.field;

        return {
          colId: col.field,
          field: col.field,
          headerName: headerLabel,
          minWidth: isFixedCompactColumn ? compactWidth : 96,
          width: isFixedCompactColumn ? compactWidth : undefined,
          flex: isFixedCompactColumn ? 0 : 1,
          sortable: col.sortable !== false,
          suppressHeaderMenuButton: false,
          tooltipValueGetter: (params) => {
            const value = params.valueFormatted ?? params.value;
            if (value === null || value === undefined || value === '') return '';
            if (typeof value === 'object') return '';
            return String(value);
          },
          valueGetter: col.renderCell
            ? undefined
            : (params) => {
                if (typeof col.valueGetter === 'function') {
                  return col.valueGetter(params.value, params.data);
                }
                return params.data?.[col.field];
              },
          cellRenderer: col.renderCell
            ? (params) => col.renderCell({ row: params.data, value: params.value })
            : undefined,
        };
      }),
    [columns],
  );

  const worklistRows = approvedAppointmentId
    ? (appointments || []).filter((apt) => apt._id === approvedAppointmentId)
    : appointments || [];

  const generateBtnLabel =
    docActionType === 'generatedatewisereport'
      ? loadingDateWiseReport
        ? 'Generating...'
        : 'Generate Date Wise Invoice'
      : docActionType === 'generatereceipt'
        ? loadingReceipt
          ? 'Generating...'
          : 'Generate Receipt'
        : docActionType === 'generateprescription'
          ? loadingPrescription
            ? 'Generating...'
            : 'Generate Prescription'
          : loadingInvoice
            ? 'Generating...'
            : 'Generate Invoice';

  const isGenerating =
    (docActionType === 'generatedatewisereport' && loadingDateWiseReport) ||
    (docActionType === 'generatereceipt' && loadingReceipt) ||
    (docActionType === 'generateprescription' && loadingPrescription) ||
    (docActionType === 'generatereport' && loadingInvoice);

  const handlePresetChange = (value) => {
    if (value === 'today') {
      setIsDateFilterExplicit(true);
      selectToday();
      return;
    }
    if (value === 'week') {
      setIsDateFilterExplicit(true);
      selectLastWeek();
      return;
    }
    if (value === 'month') {
      setIsDateFilterExplicit(true);
      selectLastMonth();
      return;
    }
    setIsDateFilterExplicit(false);
    setActiveRange('');
  };

  return (
    <div className={pageStyles.page}>
      <div className={pageStyles.head}>
        <h2 className={pageStyles.title}>Appointments</h2>
      </div>

      <Card className={pageStyles.controlCard}>
        <div className={pageStyles.controlRow}>
          <div className={pageStyles.controlTop}>
          <div className={pageStyles.controlField}>
            <SearchDoctor
              open={true}
              setData={setDoctorData}
              data={doctorData}
              variant="outlined"
              name="doctor"
              size="small"
              required={false}
            />
          </div>

          <div className={pageStyles.controlField}>
            <SearchPatient open={true} setData={setPatientData} data={patientData} size="small" />
          </div>

          <TextField
            className={pageStyles.dateField}
            size="small"
            label="Start Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={dateRange[0].startDate ? moment(dateRange[0].startDate).format('YYYY-MM-DD') : ''}
            onChange={(e) => {
              setActiveRange('');
              setDateRange((prev) => [
                {
                  ...prev[0],
                  startDate: e.target.value ? new Date(e.target.value) : null,
                },
              ]);
              setIsDateFilterExplicit(Boolean(e.target.value || dateRange[0]?.endDate));
            }}
          />

          <TextField
            className={pageStyles.dateField}
            size="small"
            label="End Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={dateRange[0].endDate ? moment(dateRange[0].endDate).format('YYYY-MM-DD') : ''}
            onChange={(e) => {
              setActiveRange('');
              setDateRange((prev) => [
                {
                  ...prev[0],
                  endDate: e.target.value ? new Date(e.target.value) : null,
                },
              ]);
              setIsDateFilterExplicit(Boolean(e.target.value || dateRange[0]?.startDate));
            }}
          />

          <FormControl size="small" className={pageStyles.presetField}>
            <InputLabel id="date-preset-label">Date Range</InputLabel>
            <Select
              labelId="date-preset-label"
              value={activeRange || 'custom'}
              label="Date Range"
              onChange={(e) => handlePresetChange(e.target.value)}
            >
              <MenuItem value="today">Today</MenuItem>
              <MenuItem value="week">Last 7 days</MenuItem>
              <MenuItem value="month">Last 30 days</MenuItem>
              <MenuItem value="custom">Custom</MenuItem>
            </Select>
          </FormControl>
          </div>

          <FormControl size="small" className={pageStyles.docTypeInput}>
            <InputLabel id="doc-type-label">Document</InputLabel>
            <Select
              labelId="doc-type-label"
              value={docActionType}
              label="Document"
              onChange={(e) => setDocActionType(e.target.value)}
            >
              <MenuItem value="generatereport">Invoice</MenuItem>
              <MenuItem value="generatedatewisereport">Date Wise Invoice</MenuItem>
              <MenuItem value="generatereceipt">Receipt</MenuItem>
              <MenuItem value="generateprescription">Prescription</MenuItem>
            </Select>
          </FormControl>

          <IconButton
            size="small"
            className={pageStyles.iconActionBtn}
            onClick={() => {
              setDoctorData(null);
              setPatientData(null);
              setDateRange([
                {
                  startDate: null,
                  endDate: null,
                  key: 'selection',
                  color: '#3d91ff',
                },
              ]);
              setActiveRange('today');
              selectToday();
              setIsDateFilterExplicit(false);
              setSelectedAppointmentDate(null);
              setSelectedAppointment(null);
              setSelectedPatientFormId(null);
              setApprovedAppointmentId(null);
              setIsDisabled(true);
              navigate('/appointment');
            }}
            title="Reset filters"
          >
            <RestartAltIcon fontSize="small" />
          </IconButton>

          <Button
            size="small"
            className={pageStyles.compactActionBtn}
            variant="contained"
            disabled={!selectedAppointment || isGenerating}
            onClick={() => openGenerateDialog()}
            startIcon={isGenerating ? <CircularProgress size={16} color="inherit" /> : null}
          >
            {generateBtnLabel}
          </Button>
        </div>

        <Dialog
          open={docGenDialogOpen}
          onClose={() => setDocGenDialogOpen(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle className={pageStyles.docDialogTitle}>Include Stamp & Signature?</DialogTitle>
          <DialogContent>
            <FormControlLabel
              control={
                <Checkbox
                  checked={docGenIncludeSignAndStamp}
                  onChange={(e) => setDocGenIncludeSignAndStamp(e.target.checked)}
                />
              }
              label="Include stamp and signature in the generated document"
            />
          </DialogContent>
          <DialogActions className={pageStyles.docDialogActions}>
            <Button className={pageStyles.docDialogCancelBtn} onClick={() => setDocGenDialogOpen(false)}>
              Cancel
            </Button>
            <Button
              className={pageStyles.docDialogGenerateBtn}
              onClick={() => {
                setDocGenDialogOpen(false);
                if (docGenType) {
                  handleGenerate(docGenType, {
                    includeSignature: docGenIncludeSignAndStamp,
                    includeStamp: docGenIncludeSignAndStamp,
                  });
                }
              }}
              variant="contained"
            >
              Generate
            </Button>
          </DialogActions>
        </Dialog>
      </Card>

      <Card className={`${Style.tableCard} ${pageStyles.tableCard}`}>
        <div className={pageStyles.tableHead}>
          <h2 className={pageStyles.tableTitle}>Appointment Worklist</h2>
        </div>
        {/* Filter appointments if approvedAppointmentId is set */}
        <CommonAgGrid
          rowData={worklistRows}
          columnDefs={appointmentColumns}
          getRowId={(p) => String(p.data?._id)}
          loading={apptLoading}
          className={`ag-theme-quartz ${pageStyles.compactAg}`}
          height={280}
          rowHeight={32}
          headerHeight={32}
          pagination
          paginationMode={approvedAppointmentId ? 'client' : 'server'}
          rowCount={approvedAppointmentId ? worklistRows.length : Number(totalCount) || 0}
          pageSizeOptions={[5, 10, 25, 50, 100]}
          paginationModel={{
            page: approvedAppointmentId ? 0 : page,
            pageSize: approvedAppointmentId ? 5 : pageSize,
          }}
          onPaginationModelChange={approvedAppointmentId ? undefined : handlePaginationModelChange}
        />

        <SessionDialog
          open={openSessionDialog}
          onClose={() => setOpenSessionDialog(false)}
          appointment={selectedApptForSession}
          onSave={handleSaveSession}
          doctors={doctorOptions}
        />

        <SessionDialogPackage
          open={openPackageSessionDialog}
          onClose={() => { setOpenPackageSessionDialog(false); setPackageEditMode(false); }}
          appointment={selectedApptForSession}
          onSave={handleSavePackageSession}
          doctors={doctorOptions}
          isEdit={packageEditMode}
        />

        <SessionSummaryDialog
          open={openSummaryDialog}
          onClose={() => setOpenSummaryDialog(false)}
          appointment={selectedApptForSummary}
        />

        <SessionEnhancementDialog
          open={openEnhancementDialog}
          onClose={() => setOpenEnhancementDialog(false)}
          sessions={selectedSessions}
        />

        <PatientFormDialog
          open={open}
          editData={editData}
          setOpen={setOpen}
          operationMode={operationMode}
          setOperationMode={setOperationMode}
          callApi={callApi}
        />

        <PaymentDialog
          open={openPayment}
          handleClose={() => setOpenPayment(false)}
          appointmentId={selectedApptId}
          appointmentDetails={selectedApptData?._id}
          callApi={callApi}
        />

        <TransactionHistoryDialog
          open={openTransaction}
          setOpen={setOpenTransaction}
          paymentLog={(selectedApptData && selectedApptData.paymentLog) || []}
        />

        <DeleteDialog
          open={deleteOpen}
          onClose={handleCancelDelete}
          onConfirm={handleConfirmDelete}
        />
      </Card>
    </div>
  );
}
